import { LogLevel } from "@azure/msal-browser";
import { getEnv } from "./runtimeEnv";

// redirect URI 기본값 — 현재 접속한 origin 에서 파생한다.
// 환경별로 명시가 필요하면 Helm web.env 의 AZURE_REDIRECT_URI 로 덮어쓴다
// (Azure App Registration 에 등록된 URI 와 정확히 일치해야 한다).
const defaultRedirectUri =
  typeof window !== "undefined" ? `${window.location.origin}/login` : undefined;

// MSAL 설정
// 값은 **런타임**에 window.__ENV__ 에서 읽는다 (빌드타임 상수 아님).
// 그래야 dev 에서 만든 이미지를 그대로 prd 로 promote 할 수 있다.
export const msalConfig = {
  auth: {
    clientId: getEnv("AZURE_CLIENT_ID"), // Azure Portal에서 받은 Application (client) ID
    authority: "https://login.microsoftonline.com/" + getEnv("AZURE_TENANT_ID"), // Azure Portal에서 받은 Directory (tenant) ID
    redirectUri: getEnv("AZURE_REDIRECT_URI", defaultRedirectUri), // 리디렉션 URI (현재 애플리케이션 URL)
  },
  cache: {
    cacheLocation: "localStorage", // 로그인 상태를 localStorage에 저장
    storeAuthStateInCookie: false, // IE11 또는 Edge를 지원하려면 true로 설정
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          // case LogLevel.Info:
          //   console.info(message);
          //   return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// 로그인 요청 시 요청할 권한
export const loginRequest = {
  scopes: ["User.Read"],
};



